import {SelectParam} from 'antd/lib/menu';
import * as React from 'react';
import {RouteComponentProps, withRouter} from 'react-router';
import {default as auth} from '../../utils/auth';
import Menu from './Menu';
import './SidebarStyles.css';

export interface SidebarProps extends RouteComponentProps {
  regions: Array<Region>;
}

const Sidebar: React.FC<SidebarProps> = ({regions, location, history}) => {
  const [routePath, region] = location.pathname.substr(1).split('/');

  function getDefaultOpenKeys() {
    switch (routePath) {
      case 'orders-history':
        return ['ordersHistorySubmenu'];
      case 'memberships':
        return ['membershipsSubmenu'];
      case 'starterpacks':
        return ['starterpacksSubmenu'];
      default:
        return [];
    }
  }

  function getSelectedKeysFromPath() {
    switch (routePath) {
      case 'orders-history':
        return [region ? `orders-history/${region}` : 'orders-history'];
      case 'memberships':
        return [region ? `memberships/${region}` : 'memberships'];
      case 'starterpacks':
        return [region ? `starterpacks/${region}` : 'starterpacks'];
      case 'payment-history':
        return [region ? `payment-history/${region}` : 'payment-history'];
      default:
        return [routePath];
    }
  }

  const logoutIfLogoutClicked = ({key}: SelectParam) => {
    if (key === 'logOut') {
      auth.logout();
      history.push('/');
    }
  };

  return (
    <>
      <h2 className="sidebar-header">Sales BackOffice</h2>
      <Menu
        selectedKeys={getSelectedKeysFromPath()}
        defaultOpenKeys={getDefaultOpenKeys()}
        logoutIfLogoutClicked={logoutIfLogoutClicked}
        regions={regions}
      />
    </>
  );
};

export default withRouter(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.tsx